import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

/**
 * All dialog styling hangs off the `dialog-open` body class, so it has to survive until the very last dialog
 * is gone - closing one of two stacked dialogs used to strip the styling of the remaining one.
 */
@Injectable({
  providedIn: 'root',
})
export class DialogOpenService {
  private readonly renderer: Renderer2;
  private openDialogs = 0;

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public open(): void {
    this.openDialogs++;

    if (this.openDialogs === 1) {
      this.renderer.addClass(this.document.body, 'dialog-open');
    }
  }

  public close(): void {
    this.openDialogs = Math.max(this.openDialogs - 1, 0);

    if (this.openDialogs === 0) {
      this.renderer.removeClass(this.document.body, 'dialog-open');
    }
  }
}
